var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CloActivityBadge',{attrs:{"badges":_vm.badges,"title":_vm.comName,"reverse":""}})}
var staticRenderFns = []

export { render, staticRenderFns }